import { render, staticRenderFns } from "./SecaoBemEstarSono.vue?vue&type=template&id=25a47cb8&scoped=true"
import script from "./SecaoBemEstarSono.vue?vue&type=script&lang=js"
export * from "./SecaoBemEstarSono.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a47cb8",
  null
  
)

export default component.exports